<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    color: #768192;
    border-color: none; 
    border : none;
    background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader
      class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center"
    >
      Petugas Back Office 
      <template v-if="role_status && role_status.status_export_excel">
      <CButton
        color="info"
        class="btn-md ml-auto mr-2"
        @click="exportPetugasIapiAktif"
        >Ekspor Excel</CButton>
      </template>
      <template v-else>
      <CButton
        color="secondary"        
        class="btn-md ml-auto button-md-block px-3"
        disabled>Ekspor Excel</CButton>
      </template>
      

 
      <template v-if="role_status && role_status.status_create">
        <router-link 
        to="/user-manajemen/petugas-iapi-tambah"
        class="btn btn-success"       
        >
          Tambah
        </router-link>
      </template>
      <template v-else>
        <router-link 
        to="/user-manajemen/petugas-iapi-tambah"
        class="btn btn-secondary"  
        tag="button"
        :disabled="true"     
        >
          Tambah
        </router-link>
      </template>

      
    </CCardHeader>

    <!-- Tabs -->
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item">
        <router-link
          to="/user-manajemen/petugas-aktif"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          style="background-color:#486ba7"
          aria-controls="home"
          aria-selected="true">Aktif
          <span class="badge ml-1 badge-success text-white">{{ totalPetugasAktif }}</span>
        </router-link>
      </li>

      <li class="nav-item">
        <router-link
          to="/user-manajemen/petugas-tidak-aktif"
          class="nav-link p-3 px-4 font-weight-bold text-white"
          id="profile-tab"
          data-toggle="tab"
          href="#profile"
          role="tab"
          aria-controls="profile"
          aria-selected="false" >Tidak Aktif
          <span class="badge ml-1 badge-danger text-white">{{ totalPetugasTidakAktif }}</span>
        </router-link>
      </li>
    </ul>
    <!-- Tabs End -->

    <div class="card-body">
      <div class="row">
        <CCol xl="12">
          <CSelect
            label="Data Perhalaman"
            class="float-left"
            @change="changePageSize"
            :options="[10, 25, 100, 'Semua Data']"
          />
          <CInput
            label="Pencarian"
            class="float-right"
            placeholder="Cari Data .."
            v-model="search"
          />
          <br />
        </CCol> 
      </div>
      <div class="row">
        <CCol lg="12" class="table-responsive">
          <CDataTable 
            style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{ index}">
              <td class="py-2">{{ index+1 }}</td>
            </template>

            <template #name="{item}">
              <td class="py-2">{{item.name ? item.name : "-"}}</td>
            </template>

            <template #nama_cabang="{item}">
              <td class="py-2">{{item.nama_cabang ? item.nama_cabang : "-"}}</td>
            </template>

            <template #nama_divisi="{item}">
              <td class="py-2">{{item.nama_divisi ? item.nama_divisi : "-"}}</td>
            </template>

            <template #status="{item}">
              <td class="py-2 text-center">
                <font-awesome-icon icon="check" class="text-success" v-if="item.status == 1" />
                <font-awesome-icon icon="times" class="text-danger" v-else />
              </td>
            </template>

            <template #aksi="{item, index}">              
              <td class="py-2 text-center">
                <template v-if="role_status && role_status.status_update">
                  <router-link :to="'/user-manajemen/petugas-iapi-edit/' + item.id">
                    <CButton v-c-tooltip="'Ubah'" color="info" square class="btn-sm mr-1">
                      <font-awesome-icon icon="edit" />
                    </CButton>
                  </router-link>&nbsp;&nbsp;
                </template>
                <template v-else>
                <router-link :to="'/user-manajemen/petugas-iapi-edit/' + item.id" tag="button" :disabled="true">
                    <CButton v-c-tooltip="'Ubah'" color="secondary" square class="btn-sm mr-1">
                      <font-awesome-icon icon="edit" />
                    </CButton>
                  </router-link>&nbsp;&nbsp;
                </template>
                <template v-if="role_status && role_status.status_delete">
                <CButton v-c-tooltip="'Hapus'" color="danger" square size="sm" @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
                <template v-else>
                <CButton v-c-tooltip="'Hapus'" color="secondary" square size="sm" disabled>
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />  
        </CCol>
      </div>
    </div>
  </CCard>
</template>
<script>
import PetugasIapiService from "../../../services/user-manajemen/petugas-iapi.service";
import { AlertUtils } from "../../../mixins/AlertUtils";
import { exportUtils } from '../../../mixins/exportUtils';

const fields = [
  { key: "no" },
  { key: "name", label: "Nama" },
  { key: "username" },
  { key: "email" },
  { key: "nama_cabang", label: "Cabang" },
  {
    key: "nama_divisi",
    label: "Divisi"
  },
  { key: "status", _style: " text-align: center" },
  { key: "aksi", _style: "width:10%; text-align: center" }
];

export default {
  name: "PetugasIapi",
  mixins : [
    AlertUtils,
    exportUtils
  ],
  data() {
    return {
      items: [],
      totalPetugasTidakAktif: 0,
      totalPetugasAktif: 0,
      actionPost: "",
      formData: {
        nama: "",
        tipe_petugas: "",
        nama_divisi: "",
        no_telephone: "",
        nama_cabang: "",
        dibuat_pada: "",
        email: "",
        username: "",
        id: ""
      },
      pagination: {
        totalPages: 0
      },
      search: "",
      pageSize: "10",            
      currentPage: 0,
      fields,      
      indexed: 0,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
      role_status: null
    };
  },

  mounted() {
    this.getData("0", this.pageSize, "default");
    this.roleData();
  },  

  watch: {
    search: function (val) {
      clearTimeout(this.timeout);
      var vm = this
      this.timeout = setTimeout(function () {          
        vm.getData("0", vm.pageSize, vm.search);
      }, 1000);
    },
    
    currentPage: function(val) {      
      var page = val - 1;
      this.indexed = page * 10;      
      this.getData(val - 1, this.pageSize, this.search);      
    }
  },

  methods: {
    roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === '/user-manajemen/petugas-aktif' );  
      this.role_status = data;
    },
    pageChange() {
      this.getData("0", this.pageSize, "default");
    },
    
    deleteData(item, index) {
      this.formData = item;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            PetugasIapiService.deletePetugasIapi(this.formData)
              .then(response => {
                // comment console console.log(response);
                this.alertDeleteSuccess();
                this.getData(this.currentPage - 1, this.pageSize, this.search);
                // this.getData("0", this.pageSize, "default");
              })
              .catch(error => {
                this.alertError();
                // comment console console.log(error);
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    getData(currentPage, pageSize, filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      PetugasIapiService.getPetugasIapiAktif(currentPage, pageSize, filter)
        .then(response => {          
          this.items = response.data.data.content;                    
          this.pagination.totalPages = response.data.data.totalPages;
          this.currentPage = response.data.data.pageable.pageNumber + 1; 
          this.countData();  
          setTimeout(() => loader.hide(), 1000);
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    countData() {
      PetugasIapiService.getPetugasIapiAktif('0', '1000', 'default')
        .then(response => {
          this.totalPetugasAktif = response.data.data.content.length;
        })
        .catch(error => {
          // comment console console.log(error)
        });

      PetugasIapiService.getPetugasIapiTidakAktif('0', '1000', 'default')
        .then(response => {
          this.totalPetugasTidakAktif = response.data.data.content.length;
        })
        .catch(error => {
          // comment console console.log(error)
        })
    },

    changePageSize(e) {      
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search);
    },

    createData() {
      this.myModal = true;
      this.formData = {};
      this.actionPost = "insert";
    },

    updateData(item, index) {
      this.myModal = true;
      this.formData = item;
      this.actionPost = "update";
    },

    postData() {
      if (this.actionPost == "insert") {
        this.insertData(this.formData);
      } else if (this.actionPost == "update") {
        this.putData();
      }
    },

    insertData(formData) {
      // comment console console.log(formData);
      // comment console console.log("posat");
      PetugasIapiService.postPetugasIapi(formData)
        .then(response => {
          this.myModal = false;
          this.alertSuccess();
          this.getData("0", this.pageSize, "default");
        })
        .catch(error => {
          // comment console console.log(error);
          this.alertError();
        });
    },

    putData() {
      // comment console console.log("put");
      // comment console console.log(this.formData);

      PetugasIapiService.putPetugasIapi(this.formData)
        .then(response => {
          this.myModal = false;

          this.alertEditSuccess();

          this.getData("0", this.pageSize, "default");
        })
        .catch(error => {
          // comment console console.log(error);

          this.alertError();
        });
    },

    exportPetugasIapiAktif() {
      PetugasIapiService.exportPetugasIapiAktif()
        .then(response => {
          this.exportData(response.data, 'Petugasi-Iapi-Aktif');
          this.alertExportSuccess();
          this.getData("0", this.pageSize, "default");
        })
        .catch(error => {
          this.alertExportFailed();
          this.getData("0", this.pageSize, "default");
        })
    }
  }
};
</script>